<div *ngFor="let kodJazykIteracia of kodJazykIN.split(', ');
    let index = index; first as first1; last as last1"
  [ngClass]="{'mb-2': first1, 'my-3': !first1}"
  >

  <app-header-polozka
    [typ]="typZaznamuTextu"
    [kodJazyk]="kodJazykIteracia"
    [formularFormGroup]="formularFormGroup"
    [zobrazitCopyButton]="index === 0 && kodJazykIN.length > 2">
  </app-header-polozka>

  <div *ngIf="typZaznamuTextu.opakovanie === 'A' || jeOpakovaniePodprogramu; else neopakovanaPolozka"
      formArrayName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}">

    <!-- OPAKOVANE POLOZKY -->
    <div *ngFor="let controlFromArray of mapaJazykovAFormArrays.get(kodJazykIteracia).controls;
          let i = index; first as first; last as last"
        [ngClass]="{'medzera-top': i > 0 && typZaznamuTextu.opakovanie === 'A'
            && !appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i-1),
          'mt-2' : i === 0,
          'mb-5 pb-3' : last && !first}"
        >

      <!-- SWAPOVACI BUTTON -->
      <div class="d-flex mb-2">
        <button *ngIf="i > 0 && i < mapaJazykovAFormArrays.get(kodJazykIteracia).controls.length"
          class="ms-auto"
          style="margin-top: -13px;"
          mat-icon-button
          type="button"
          (click)="vymenPolozky(i, kodJazykIteracia)"
          [matTooltip]="getVymenitObsahPoloziekTooltip()"
          aria-label="Vymeniť obsah položiek">
          <mat-icon>swap_vert</mat-icon>
        </button>
      </div>

      <div *ngIf="typZaznamuTextu.vazba === appStateService.VAZBA_STUPEN_TYP_STUDIA
          && index === 0"
        class="d-flex justify-content-end">

        <app-stupen-typ-studia
          [idTyp]="typZaznamuTextu.id"
          [poradieOpakovanejPolozky]="i+1">
        </app-stupen-typ-studia>

      </div>


        <!-- TODO: stud. programy podprogramu
        [ngStyle]="{'margin-top': i > 0 && jeOpakovaniePodprogramu ? '5rem' : '1em'}">
        -->
      <div [ngClass]="{'d-flex flex-row': typZaznamuTextu.opakovanie === 'A'
        || appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)}">

        <div *ngIf="typZaznamuTextu.opakovanie === 'A'" class="mt-2 me-2 h5">{{i+1}}.</div>
        <!--
          TODO: toto pridame nizsie az ked budee riesit dialog pre vyber stud. programov
          [ngClass]="{'mb-2': last && !appStateService.mapaIdTypovAZaznamovsPodprogramami.get(this.typZaznamuTextu.id)}"
        -->
        <quill-editor
          class="sirka-editora"
          [ngStyle]="{'margin-bottom': !last
            &&
            (!appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i)
              || appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i).length === 0)
            ? '1em' : '0em',
            'margin-left': (mapaJazykovAFormArrays.get(kodJazykIteracia).length > 9 && i < 9) ? '.71rem' : ''}"
          id="name_{{typZaznamuTextu.id}}_{{i}}_{{kodJazykIteracia}}"
          [formControlName]="i"
          [styles]="{'min-height': '200px', resize: 'vertical',
            'background-color': typZaznamuTextu.uroven === 2
              && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty ? 'whitesmoke' : '',
            disabled: true}"
          [placeholder]="getPlaceholder(kodJazykIteracia)"
          [modules]="quillConfiguration">
        </quill-editor>

        <!-- TODO: chceme, aby sa v pripade formulara pre podprogram a atributu podprogram === 1 zobrazoval button na pridanie opakovanej polozky -->
        <!-- - to bude az v dalsej faze - vtedy podmienku "&& !(typZaznamuTextu.podprogram > 0)" dame prec! -->
        <div *ngIf="last && (typZaznamuTextu.opakovanie === 'A'
            || (appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)))" class="mt-2 ms-2">
          <button mat-mini-fab color="primary" type="button" (click)="pridatPolozku(kodJazykIteracia)"
              [matTooltip]="getPridatPolozkuTooltip()"
              [disabled]="typZaznamuTextu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
              <mat-icon>add</mat-icon>
          </button>
        </div>

      </div>


      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)
        && appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i)"
        class="ms-1 mb-3 font-italic"
        [ngClass]="{'ms-4': typZaznamuTextu.opakovanie === 'A',
          'pomocny-text': typZaznamuTextu.opakovanie === 'A'
            || appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu) && !last,
          'pomocny-text-last': typZaznamuTextu.opakovanie === 'A'
            || appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu) && last,
          'mt-1':typZaznamuTextu.opakovanie !== 'A'
            && !appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)}">

          {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu, kodJazykIteracia, i)}}
      </div>

      <!-- POLICKO PRE STUD. PROGRAMY ZAZNAMU TEXTU PODPROGRAMU A BUTTON PRE ICH VYBER -->
      <div *ngIf="appStateService.zobrazitButtonOpakovaniaPrePodprogram(typZaznamuTextu)"
        [ngClass]="{'mb-5': !last}">
        <app-studijne-programy-zaznamu
          [typZaznamuTextu]="typZaznamuTextu"
          [kodJazyk]="kodJazykIteracia"
          [poradiePolozkyVoFormulari]="i+1"
          [mapaJazykovAFormArrays]="mapaJazykovAFormArrays">
        </app-studijne-programy-zaznamu>
      </div>

    </div>

  </div>


  <!-- https://github.com/quilljs/quill/blob/f75ff2973f068c3db44f949915eb8a74faf162a8/docs/_includes/full-toolbar.html -->
  <!-- https://www.npmjs.com/package/ngx-quill -->

  <!-- <quill-editor
    class="sirka-editora"
    id="name_{{typZaznamuTextu.id}}_SK"
    formControlName="name_{{typZaznamuTextu.id}}_SK"
    [styles]="{'min-height': '200px', resize: 'vertical'}"
    [placeholder]="getPlaceholder('SK')"
    [modules]="quillConfiguration"> -->

    <!-- [styles]="{'min-height': '120px', resize: 'vertical'}" -->

    <!--
      <div quill-editor-toolbar>
        <span class="ql-formats">
          <button class="ql-bold" [title]="'Tučné'"></button>
          <button class="ql-italic" [title]="'Kurzíva'"></button>
          <button class="ql-underline" [title]="'Podčiarknuté'"></button>
          <button class="ql-strike" [title]="'Preškrtnuté'"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-align" [title]="'Zarovnanie'">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered" [title]="'Číslovaný zoznam'"></button>
          <button class="ql-list" value="bullet" [title]="'Zoznam'"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-font">
            <option selected></option>
            <option value="serif"></option>
            <option value="monospace"></option>
          </select>
          <select class="ql-size">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
        </span>
      </div>
    -->

  <!-- </quill-editor> -->

  <ng-template #neopakovanaPolozka>
    <div *ngIf="!typZaznamuTextu.idSkupina || typZaznamuTextu.idSkupina === 0;else skupinovaPolozka">

      <div *ngIf="typZaznamuTextu.uroven === 2
        && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
          class="text-warning" i18n>
          *položka je editovateľná len z úrovne fakulty
      </div>

      <quill-editor
        class="sirka-editora"
        id="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
        formControlName="name_{{typZaznamuTextu.id}}_{{kodJazykIteracia}}"
        [styles]="{'min-height': '200px', resize: 'vertical',
        'background-color': typZaznamuTextu.uroven === 2
        && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty ? 'whitesmoke' : ''}"
        [placeholder]="getPlaceholder(kodJazykIteracia)"
        [modules]="quillConfiguration">
      </quill-editor>

      <!-- pomocny text pre polozku podprogramu vo formulari PODPROGRAMu -->
      <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
        class="ms-1 mb-3 mt-1 font-italic">

          {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
      </div>

    </div>

    <ng-template #skupinovaPolozka>
      <div formArrayName="name_{{typZaznamuTextu.idSkupina}}_{{kodJazykIteracia}}">
        <quill-editor
          class="sirka-editora"
          id="name_{{typZaznamuTextu.id}}_{{typZaznamuTextu.idSkupina}}_{{indexPolozkyVoFormulari}}_{{kodJazykIteracia}}"
          [formControlName]="indexPolozkyVoFormulari"
          [styles]="{'min-height': '200px', resize: 'vertical'}"
          [placeholder]="getPlaceholder(kodJazykIteracia)"
          [modules]="quillConfiguration">
        </quill-editor>

        <!-- pomocny text pre polozku podprogramu vo formulari PODPROGRAMu -->
        <div *ngIf="appStateService.zobrazitPomocnyTextPolozkyPodprogramu(typZaznamuTextu)"
          class="ms-1 mb-3 mt-1 font-italic">

            {{appStateService.getSpolocnaPolozkaPodprogramuText(typZaznamuTextu)}}
        </div>

      </div>
    </ng-template>

  </ng-template>


</div>
